export const environment = {
  production: true,
  apiURL: 'https://fushit-dev.30hills.com/api/v1',
};
